// style pour le composant tableau car on ne peut integrer le css directement dans les données  

export const serviceTypeStyle = {
  container: {
    display: 'flex',
    gap: '8px'
  }
};

export const supplierStyle = {
  email: {
    fontSize: '12px',
    color: '#6b7280'
  }
};

export const statusStyle = (value) => ({
  padding: '4px 8px',
  borderRadius: '12px',
  fontSize: '12px',
  fontWeight: '500',
  textTransform: 'uppercase',
  color: 'white',
  background:
    value === 'draft'
      ? '#6b7280'
      : value === 'pending'
      ? '#f59e0b'
      : value === 'accepted'
      ? '#10b981'
      : '#ef4444'
});

export const activeStatusStyle = (value) => ({
  padding: '4px 8px',
  borderRadius: '12px',
  fontSize: '12px',
  fontWeight: '500',
  textTransform: 'uppercase',
  color: 'white',
  background: value === 'actif' ? '#10b981' : '#ef4444'
});

export const getCompletionColor = (percentage) => {
  if (percentage >= 80) return '#10b981';
  if (percentage >= 50) return '#f59e0b';
  return '#ef4444';
};
